import { defineMessages } from 'react-intl-next';

const messages: {
	cancelButtonTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	continueButtonTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorInputCharacterLimitReached: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorInputMustNotBeEmpty: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorInputTypeIsNotSupported: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorValueIsNotValidNumber: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	failureFlagDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	failureFlagTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	inputRequiredForAction: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	partialFailureFlagDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	successFlag: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	successFlag: {
		id: 'automation-platform.common.success-flag',
		defaultMessage: 'Your automation is in progress',
		description: 'The text is shown as a success message to confirm the automation rule has been triggered successfully.',
	},
	failureFlagTitle: {
		id: 'automation-platform.common.failure-flag-title',
		defaultMessage: 'Oops we ran into a problem',
		description: 'The text is shown as an error message title when the automation rule fails to be triggered.',
	},
	failureFlagDescription: {
		id: 'automation-platform.common.failure-flag-description',
		defaultMessage: "There was a problem and we couldn't run the automation '{0}'",
		description: 'The text is shown as error details when the automation rule fails where {0} is the automation rule name.',
	},
	partialFailureFlagDescription: {
		id: 'automation-platform.common.partial-failure-flag-description',
		defaultMessage:
			"Couldn't run the automation against issues {0}, please ensure you have permission to view these issues",
		description:
			'The text is shown as error details when some issues failed due to permission restrictions where {0} is the list of issues.',
	},
	errorInputMustNotBeEmpty: {
		id: 'automation-platform.common.error-input-must-not-be-empty',
		defaultMessage: 'Input must not be empty',
		description: 'The text is shown as an error message when the user leaves a required input field empty.',
	},
	errorInputCharacterLimitReached: {
		id: 'automation-platform.common.error-input-character-limit-reached',
		defaultMessage: 'Provided value exceeds the character limit for the field.',
		description:
			'The text is shown as an error message when the user input exceeds the maximum character limit for a field.',
	},
	inputRequiredForAction: {
		id: 'automation-platform.common.input-required-for-action',
		defaultMessage: 'Your input is required to complete this action',
		description: 'The text is shown as a modal title when user input is required to proceed with an action.',
	},
	errorInputTypeIsNotSupported: {
		id: 'automation-platform.common.error-input-type-is-not-supported',
		defaultMessage: 'Input type not supported yet',
		description: 'The text is shown as an error message when the user input type is not supported or recognized.',
	},
	errorValueIsNotValidNumber: {
		id: 'automation-platform.common.error-value-is-not-valid-number',
		defaultMessage: 'The value is not a valid number',
		description:
			'The text is shown as an error message when a number input field contains a value that is not a valid number.',
	},
	cancelButtonTitle: {
		id: 'automation-platform.common.cancel-button-title',
		defaultMessage: 'Cancel',
		description: 'The text is shown on a button to dismiss the automation action or modal without executing.',
	},
	continueButtonTitle: {
		id: 'automation-platform.common.continue-button-title',
		defaultMessage: 'Continue',
		description: 'The text is shown on a button to proceed with the automation action or next step in a workflow.',
	},
});

export default messages;
